/**
 * Notification system context.
 */
import React from 'react'
import NotificationSystem from 'react-notification-system'

export const NotificationContext = React.createContext(null)
export const NotificationConsumer = NotificationContext.Consumer

interface NotificationStoreProps {
  children: any
}

export interface NotificationContext {
  addNotification: Function
  addErrorNotification: Function
}

export class NotificationStore extends React.Component<NotificationStoreProps> {
  notificationSystem: NotificationSystem

  state = {
  }


  addNotification = (notification: any) => {
    if (this.notificationSystem) {
      this.notificationSystem.addNotification(notification)
    } else {
      console.log('No notification system for', notification)
    }
  }

  addErrorNotification = (err: any, options?: object) => {
    if (this.notificationSystem) {
      this.addNotification(Object.assign({
        level: 'error',
        message: err.message || ('' + err),
        autoDismiss: 0,
        dismissible: 'button',
      }, options || {}))
    } else {
      console.log('No notification system for error', err)
    }
  }

  async componentDidMount() {
  }

  render() {
    return (
      <NotificationContext.Provider value={{
        addNotification: this.addNotification,
        addErrorNotification: this.addErrorNotification,
      }}>
        {this.props.children}
        <NotificationSystem ref={(notificationSystem: any) => this.notificationSystem = notificationSystem}/>
      </NotificationContext.Provider>
    )
  }
}

export function withNotificationContext(Comp: any) {
  return (props: any) => (
    <NotificationContext.Consumer>
      {(notificationContext: NotificationContext) => <Comp {...props} notificationContext={{...notificationContext}}/>}
    </NotificationContext.Consumer>
  )
}
